import script from "./DeploymentList.vue?vue&type=script&setup=true&lang=js"
export * from "./DeploymentList.vue?vue&type=script&setup=true&lang=js"

import "./DeploymentList.vue?vue&type=style&index=0&id=1e4e5d58&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e4e5d58"]])

export default __exports__